
import React, {Component} from 'react'
import {Panel} from 'react-bootstrap'
import { Offline, Online,Detector } from "react-detect-offline";
import NotificationSystem from 'component/element/NotificationSystem'
import FontAwsome from 'react-fontawesome'
//var NotificationSystem = require('react-notification-system');

class DetectOffline extends Component {

  constructor(...args) {
    super(...args)
    this.state = {online:true}
  }

  componentDidMount() {
    
  }


  renderOffline(){
      return (<div className="panel panel-danger text-center" style={{width:'450px',margin: 'auto'}}>
                    <div className="panel-heading"><FontAwsome name='eye-slash' />&nbsp;อินเตอร์เน็ตออฟไลน์</div>
                    <div className="panel-body">
                        โปรดตรวจสอบสัญญาณอินเตอร์
                    </div>
                </div>
      )
  }
  

  renderOnline(){
      return (<div></div>)
  }

  onNetworkChange(online){
      console.log('test',online)
      this.setState({online:online})

      if(online){
        this.refs.notificationSystem.clearNotifications()
        this.refs.notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'อินเตอร์เน็ตกลับมาใช้งานได้ปกติ',
            level: 'success',
            position: 'tc'
          })
      }else{
        this.refs.notificationSystem.addNotification({
            title: 'แจ้งเตือน',
            message: 'อินเตอร์เน็ตใช้งานไม่ได้ กรุณาตรวจสอบ',
            level: 'error',
            autoDismiss:0,
            position: 'tc',
            action: {
                label: 'รับทราบ',
                callback: function() {
                  console.log('Clicked');
                }
              }
          })
      }
  }

  render() {
    //let {online} = this.state
    const polling = {
      enabled: false,
      interval: 10000,
      timeout: 1000
    };
    return(
      <div>
        <div>            
            <Detector
                polling={polling}
                render={({ online }) => (
                    <div>{online?<div/>:this.renderOffline()}</div>                    
                  )}
                onChange={this.onNetworkChange.bind(this)}
                />
        </div>
        <NotificationSystem ref='notificationSystem'/>
      </div>
    )
  }
}

DetectOffline.defaultProps = {

}


export default DetectOffline;








// WEBPACK FOOTER //
// ./src/view/notification/DetectOffline.js